import { Dispatch, SetStateAction } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import { PersonalInformation } from '../../types/PersonalInformation';
import EditFamilyMember from './EditFamilyMember';
import BackLink from '../../BackLink';
import * as constants from '../../constants';
import { ApiResource } from '../../api/ApiResource';
import { PostalCodeResponse } from '../../api/postalCodeAPI';

interface EditBarnProps {
    postalCodesListResource: ApiResource<PostalCodeResponse>;
    barn: PersonalInformation[];
    setBarn: Dispatch<SetStateAction<PersonalInformation[] | undefined>>;
}

export default function EditBarnPage({ barn, setBarn, postalCodesListResource }: EditBarnProps) {
    const navigate = useNavigate();
    let { id } = useParams();

    if (id === undefined || barn === undefined) {
        navigate('familie');
    }

    const barneId = parseInt(id ?? '');
    const barneIndex = barneId >= 1 ? barneId - 1 : 0;

    const barnInfo =
        barneId > barn.length
            ? {
                  phoneNumber: '',
                  firstname: '',
                  lastname: '',
                  email: '',
                  address: '',
                  postalcode: '',
                  dateOfBirth: '',
                  newsletter: false,
              }
            : barn[barneIndex];

    const setBarnInput = (childInfo: PersonalInformation, index?: number) => {
        if (index !== undefined) {
            if (index > barn.length) {
                barn.push(childInfo);
            } else {
                let items = [...barn];
                items[index] = childInfo;
                setBarn(items);
            }
        }
    };

    return (
        <div>
            <BackLink destination={constants.LINK_TO_FAMILY_PAGE} />
            <EditFamilyMember
                postalCodesListResource={postalCodesListResource}
                isHovedmedlem={false}
                isBarn={true}
                index={barneIndex}
                formInput={barnInfo}
                setFormInput={setBarnInput}
            />
        </div>
    );
}
